import React from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';

import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';

import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoPresentation } from '../../../../contexts/PromoPresentationProvider';
import { BogoSecondaryMessaging } from './subcomponents/BogoSecondaryMessaging/BogoSecondaryMessaging';
import { MsbSecondaryMessaging } from './subcomponents/MsbSecondaryMessaging/MsbSecondaryMessaging';
import { formatPrice } from '../../../../utils/promo-presentation-utils';
import './MessagingContainer.scss';

export const MessagingContainer = ({ isInPromoDrawer }) => {
  const {
    isBogo,
    isMsb,
    subExperience,
    rewardPercent,
    minPurchaseQuantity,
    minPurchaseAmount,
    rewardAmountPerOrder,
    rewardAmountPerItem,
    hasProducts
  } = usePromoModel();

  const { isCartLoading } = usePromoCart();
  const { isBatchLoading } = usePromoPresentation();
  const showBogoMessaging = hasProducts && isBogo;
  const showMsbMessaging = hasProducts && isMsb;

  const messagingContainerClasses = classNames('promo-messaging-container',
    {
      'promo-messaging-container--slim': !isInPromoDrawer && isBogo,
      'promo-messaging-container--in-drawer': isInPromoDrawer,
    });

  const secondaryMessagingClasses = classNames({
    'promo-messaging-container-sold-out-message': !hasProducts,
    'promo-messaging-container-secondary-message': hasProducts,
  });

  const mainMessages = {
    MSB1: <>Buy {minPurchaseQuantity} or More, Get&nbsp;{rewardPercent}%&nbsp;Off</>,
    MSB2: <>Buy {minPurchaseQuantity} or More, Save&nbsp;{formatPrice(rewardAmountPerOrder)}</>,
    MSB3: <>Buy {minPurchaseQuantity} or More, Save&nbsp;{formatPrice(rewardAmountPerItem)}&nbsp;On&nbsp;Each</>,
    MSB4: <>Spend {formatPrice(minPurchaseAmount)}, Get&nbsp;{rewardPercent}%&nbsp;Off</>,
    MSB5: <>Spend {formatPrice(minPurchaseAmount)}, Get&nbsp;{formatPrice(rewardAmountPerOrder)}&nbsp;Off</>,
    MSB6: <>Spend {formatPrice(minPurchaseAmount)}, Save&nbsp;{formatPrice(rewardAmountPerItem)}&nbsp;On&nbsp;Each</>
  };

  return (
    <div className={messagingContainerClasses} data-testid="promo-messaging-container">
      <div>
        {isBogo && <>Buy 1 Get 1&nbsp;Free</>}
        {isMsb && mainMessages[subExperience]}
      </div>
      <LoadingPlaceholder
        className="promo-messaging-container-loader"
        type="textRow"
        ready={isInPromoDrawer || (!isBatchLoading && !isCartLoading)}
        style={{ marginTop: '3px' }}
        showLoadingAnimation
      >
        <div className={secondaryMessagingClasses} data-testid="promo-secondary-messaging">
          {!hasProducts && 'This Deal Has Sold Out'}
          {showBogoMessaging && <BogoSecondaryMessaging isInPromoDrawer={isInPromoDrawer} />}
          {showMsbMessaging && <MsbSecondaryMessaging />}
        </div>
      </LoadingPlaceholder>
    </div>
  );
};

MessagingContainer.displayName = 'MessagingContainer';

MessagingContainer.propTypes = {
  isInPromoDrawer: bool,
};

MessagingContainer.defaultProps = {
  isInPromoDrawer: false
};
